<img src="assets/images/logo-smart.png" class="logo" >

<h3 id="title" class="title">{{ 'tytul.rejestracja' | translate }}</h3>

<nb-alert *ngIf="showMessages.error && errors?.length && !submitted" outline="danger" role="alert">
  <p class="alert-title"><b>{{ 'komunikat.blad.rejestracja' | translate }}!</b></p>
  <ul class="alert-message-list">
    <li *ngFor="let error of errors" class="alert-message">{{ error | translate }}</li>
  </ul>
</nb-alert>

<form (ngSubmit)="register()" #form="ngForm" aria-labelledby="title">

  <div class="form-control-group">
    <label class="label" for="input-fullName">{{ 'etykieta.imie-nazwisko' | translate }}:</label>
    <input nbInput
           [(ngModel)]="user.fullName"
           #fullName="ngModel"
           id="input-fullName"
           name="fullName"
           placeholder="{{ 'etykieta.imie-nazwisko' | translate }}"
           fullWidth
           fieldSize="large"
           [status]="fullName.dirty ? 'success' : 'basic'"
           [required]="true">
    <ng-container *ngIf="fullName.invalid && fullName.touched">
            <p class="caption status-danger">
                  {{ 'komunikat.blad.imie-nazwisko-jest-wymagane' | translate }}!
            </p>
    </ng-container>
  </div>

  <div class="form-control-group">
    <label class="label" for="input-phone">{{ 'etykieta.telefon' | translate }}:</label>
    <input nbInput
           [(ngModel)]="user.phone"
           #phone="ngModel"
           id="input-username"
           name="phone"
           placeholder="{{ 'etykieta.telefon' | translate }}"
           fullWidth
           fieldSize="large"
           [status]="phone.dirty ? (phone.invalid ? 'danger' : 'success') : 'basic'"
           [required]="true">
		<ng-container *ngIf="phone.invalid && phone.touched">
			<p class="caption status-danger" *ngIf="phone.errors?.required">
				{{ 'komunikat.blad.telefon-jest-wymagany' | translate }}!
			</p>
			<p class="caption status-danger" *ngIf="phone.errors?.pattern">
				{{ 'komunikat.blad.telefon-niepoprawny' | translate }}!
			</p>
		</ng-container>
  </div>

  <div class="form-control-group">
    <label class="label" for="input-email">{{ 'etykieta.adres-email' | translate }}:</label>
    <input nbInput
           [(ngModel)]="user.email"
           #email="ngModel"
           id="input-email"
           name="email"
           pattern=".+@.+..+"
           placeholder="E-mail"
           fullWidth
           fieldSize="large"
           [status]="email.dirty ? (email.invalid  ? 'danger' : 'success') : 'basic'"
           [required]="getConfigValue('forms.validation.email.required')"
           [attr.aria-invalid]="email.invalid && email.touched ? true : null">
    <ng-container *ngIf="email.invalid && email.touched">
      <p class="caption status-danger" *ngIf="email.errors?.required">
        {{ 'komunikat.blad.email-jest-wymagany' | translate }}!
      </p>
      <p class="caption status-danger" *ngIf="email.errors?.pattern">
        {{ 'komunikat.blad.email-niepoprawny' | translate }}!
      </p>
    </ng-container>
  </div>

  <div class="form-control-group">
    <label class="label" for="input-password">{{ 'etykieta.haslo' | translate }}:</label>
    <input nbInput
           [(ngModel)]="user.password"
           #password="ngModel"
           type="password"
           id="input-password"
           name="password"
           placeholder="{{ 'etykieta.haslo' | translate }}"
           fullWidth
           fieldSize="large"
           [status]="password.dirty ? (password.invalid  ? 'danger' : 'success') : 'basic'"
           [required]="getConfigValue('forms.validation.password.required')"
           [minlength]="getConfigValue('forms.validation.password.minLength')"
           [attr.aria-invalid]="password.invalid && password.touched ? true : null">
    <ng-container *ngIf="password.invalid && password.touched">
      <p class="caption status-danger" *ngIf="password.errors?.required">
        {{ 'komunikat.blad.haslo-jest-wymagane' | translate }}!
      </p>
      <p class="caption status-danger" *ngIf="password.errors?.minlength || password.errors?.maxlength">
        {{ 'komunikat.blad.haslo-dlugosc-poczatek' | translate }} {{ getConfigValue('forms.validation.password.minLength') }} {{ 'komunikat.blad.haslo-dlugosc-koniec' | translate }}
      </p>
    </ng-container>
  </div>

  <div class="form-control-group">
    <label class="label" for="input-re-password">{{ 'etykieta.haslo-powtorzenie' | translate }}:</label>
    <input nbInput
           [(ngModel)]="user.confirmPassword"
           #rePass="ngModel"
           type="password"
           id="input-re-password"
           name="rePass"
           placeholder="{{ 'etykieta.haslo-powtorzenie' | translate }}"
           fullWidth
           fieldSize="large"
           [status]="rePass.dirty ? (rePass.invalid || password.value != rePass.value  ? 'danger' : 'success') : 'basic'"
           [required]="getConfigValue('forms.validation.password.required')"
           [attr.aria-invalid]="rePass.invalid && rePass.touched ? true : null">
    <ng-container *ngIf="rePass.invalid && rePass.touched">
      <p class="caption status-danger" *ngIf="rePass.errors?.required">
        {{ 'komunikat.blad.pole-jest-wymagane' | translate }}!
      </p>
      <p class="caption status-danger" *ngIf="password.value != rePass.value && !rePass.errors?.required">
        {{ 'komunikat.blad.hasla-roznia-sie' | translate }}!
      </p>
    </ng-container>
  </div>

  <div>
		<div class="form-control-group accept-group checkbox position-relative" *ngIf="getConfigValue('forms.register.terms')">
			<div class="position-absolute shadow tooltip">
				{{ 'etykieta.zgoda1' | translate }}
			</div>
			<nb-checkbox name="acceptance1"
			[(ngModel)]="user.acceptance1"
      pattern="true"
			[required]="getConfigValue('forms.register.terms')">
				<span style="color: red;">*</span> {{ 'etykieta.zgoda1-skrot' | translate }}
			</nb-checkbox>
		</div>
	</div>
	
  <div>
		<div class="form-control-group accept-group checkbox position-relative" *ngIf="getConfigValue('forms.register.terms')">
			<div class="position-absolute shadow tooltip">
				{{ 'etykieta.zgoda2a' | translate }}
				<br>
				<br>
				{{ 'etykieta.zgoda2b' | translate }}
			</div>
			<nb-checkbox name="acceptance2"
			[(ngModel)]="user.acceptance2"
      pattern="true"
			[required]="getConfigValue('forms.register.terms')">
      <span style="color: red;">*</span> {{ 'etykieta.zgoda2-skrot' | translate }}
			</nb-checkbox>
		</div>
	</div>
	
  <div>
		<div class="form-control-group accept-group checkbox position-relative" *ngIf="getConfigValue('forms.register.terms')">
			<div class="position-absolute shadow tooltip">
				{{ 'etykieta.zgoda3' | translate }}
			</div>
			<nb-checkbox name="acceptance3"
			[(ngModel)]="user.acceptance3">
				{{ 'etykieta.zgoda3-skrot' | translate }}
			</nb-checkbox>
		</div>
	</div>
	
  <div>
		<div class="form-control-group accept-group checkbox position-relative" *ngIf="getConfigValue('forms.register.terms')">
			<div class="position-absolute shadow tooltip">
				{{ 'etykieta.zgoda4' | translate }}
			</div>
			<nb-checkbox name="acceptance4"
			[(ngModel)]="user.acceptance4">
				{{ 'etykieta.zgoda4-skrot' | translate }}
			</nb-checkbox>
		</div>
	</div>

  <div>
		<div class="required-consents" *ngIf="getConfigValue('forms.register.terms')">
      <span style="color: red;">*</span> {{ 'etykieta.wymagane-zgody' | translate }}
		</div>
	</div>
	
  <button nbButton
	fullWidth
	status="primary"
	size="large"
	[disabled]="submitted || !form.valid"
	[class.btn-pulse]="submitted">
	{{ 'akcja.zarejestruj' | translate }}
  </button>
</form>

<section *ngIf="socialLinks && socialLinks.length > 0" class="links" aria-label="Portale społecznościowe">
  {{ 'etykieta.logowanie-kontem-zewnetrznym' | translate }}:
  <div class="socials">
    <ng-container *ngFor="let socialLink of socialLinks">
      <a *ngIf="socialLink.link"
         [routerLink]="socialLink.link"
         [attr.target]="socialLink.target"
         [attr.class]="socialLink.icon"
         [class.with-icon]="socialLink.icon">
        <nb-icon *ngIf="socialLink.icon; else title" [icon]="socialLink.icon"></nb-icon>
        <ng-template #title>{{ socialLink.title }}</ng-template>
      </a>
      <a *ngIf="socialLink.url"
         [attr.href]="socialLink.url"
         [attr.target]="socialLink.target"
         [attr.class]="socialLink.icon"
         [class.with-icon]="socialLink.icon">
        <nb-icon *ngIf="socialLink.icon; else title" [icon]="socialLink.icon"></nb-icon>
        <ng-template #title>{{ socialLink.title }}</ng-template>
      </a>
    </ng-container>
  </div>
</section>

<section class="another-action" aria-label="Sign in">
  {{ 'etykieta.masz-juz-konto' | translate }} <a class="text-link" routerLink="../login">{{ 'akcja.zaloguj-sie' | translate }}</a>
</section>

<section class="another-action">
  <ngx-wybor-jezyka-panel></ngx-wybor-jezyka-panel>
</section>